module.exports = __webpack_public_path__ + "static/media/logo3.388420b3.png";